import React, { FC, useMemo } from 'react';
import {
    StyledCard,
    PropertyDetails,
    PropertyDetailsContainer,
    PropertyImage,
    StyledPropertyPrice,
    StyledPropertyAddress
} from '../FeaturedProperties.styles';
import { InternalPromoData } from './internalPromoData';
import { CTAWrapper } from './InternalPromoCard.styles';
import { Button, CardImage, Link } from '@blueprint/ui';

export type Props = {
    promo: InternalPromoData;
    currentSection: 'for-sale' | 'to-rent';
    searchParam?: string;
    onClick?: () => void;
};

const usePromoLink = ({ promo, currentSection, searchParam }: Props) =>
    useMemo(() => {
        if (promo.name === 'smartmap') {
            return `${currentSection}/${promo.link}/${
                searchParam ? searchParam : ''
            }`;
        } else if (promo.name === 'newhomes' && searchParam) {
            return `${promo.link}/${searchParam}`;
        }

        return promo.link;
    }, [promo, currentSection, searchParam]);

const InternalPromoCard: FC<Props> = (props) => {
    const { promo, onClick } = props;

    const link = usePromoLink(props);

    return (
        <Link
            plain
            href={`/${link}`}
            data-testid="featured-promo"
            onClick={onClick}
            {...props}
        >
            <StyledCard
                hasShadow={false}
                hasBorder={false}
                hasBackground
                contentAlignment="center"
            >
                <PropertyImage>
                    <CardImage
                        src={promo.image.src}
                        responsiveImgList={promo.image.responsiveImgList}
                    />
                </PropertyImage>
                <PropertyDetailsContainer>
                    <PropertyDetails>
                        <StyledPropertyPrice color="text-title" size="6" isBold>
                            {promo.title}
                        </StyledPropertyPrice>
                        <StyledPropertyAddress color="text-title" size="8">
                            {promo.details}
                        </StyledPropertyAddress>
                    </PropertyDetails>
                    <CTAWrapper>
                        <Button variant="secondary" isFullWidth>
                            {promo.cta}
                        </Button>
                    </CTAWrapper>
                </PropertyDetailsContainer>
            </StyledCard>
        </Link>
    );
};

export default InternalPromoCard;
